export default __webpack_public_path__ + "static/media/redTheme-boy.846d9d39.svg";